// React imports
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Controller } from 'react-hook-form';

// Material-UI imports
import {
  Paper,
  Button,
  CssBaseline,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  Container,
  Box,
  CircularProgress,
} from '@material-ui/core';
// @ts-ignore
import Alert from '@material-ui/lab/Alert';
import { VisibilityOffOutlined, VisibilityOutlined } from '@material-ui/icons';

// Other imports
// @ts-ignore
import { yupResolver } from '@hookform/resolvers/yup';
// @ts-ignore
import * as yup from 'yup';

// Absolute imports
import Logo from 'assets/Diligent_Equity.png';
import getVersion from 'utils/version';
import { routes } from 'routes';

// Relative imports
import useStyles from './PasswordResetConfirmStyles';
import { usePasswordResetConfirmPage } from './usePasswordResetConfirmPage';

export function PasswordResetConfirmPage() {
  const classes = useStyles();
  const history = useHistory();
  const { token } = useParams<{ token: string }>();
  const logic = usePasswordResetConfirmPage(token);

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Paper
        variant="outlined"
        square
        className={`${classes.paper} lens-login-form`}
      >
        <img src={Logo} alt="logo" className={classes.logo} />
        {logic.showForm ? (
          <form className={classes.form} onSubmit={logic.getOnSubmit()}>
            <p>Password Requirements</p>
            <ul>
              <li>at least 8 characters</li>
              <li>at least 1 number</li>
              <li>at least 1 upper case letter</li>
              <li>at least 1 lower case letter</li>
            </ul>
            <label className={classes.inputLabel}>Password</label>
            <Controller
              name="password1"
              control={logic.form.control}
              render={(props) => (
                <TextField
                  {...props}
                  error={!!logic.form.errors.password1}
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  // label="Email"
                  type={logic.showPassword ? 'text' : 'password'}
                  autoComplete="current-password"
                  autoFocus
                  helperText={logic.form.errors.password1?.message || ' '}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={logic.toggleShowPassword}
                          edge="end"
                        >
                          {logic.showPassword ? (
                            <VisibilityOutlined />
                          ) : (
                            <VisibilityOffOutlined />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                    classes: {
                      root: 'lens-text-field-root',
                    },
                  }}
                  classes={{
                    root: classes.formControl,
                  }}
                />
              )}
            />
            <label className={classes.inputLabel}>Password</label>
            <Controller
              name="password2"
              control={logic.form.control}
              render={(props) => (
                <TextField
                  {...props}
                  error={!!logic.form.errors.password2}
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  type="password"
                  helperText={logic.form.errors.password2?.message || ' '}
                  classes={{ root: classes.formControl }}
                />
              )}
            />

            {logic.errorMessage && (<Alert severity="error">{logic.errorMessage}</Alert>)}

            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              disabled={logic.isLoading}
            >
              {logic.isLoading ? <CircularProgress size={24} /> : 'Reset'}
            </Button>
          </form>
        ) : (
          <div style={{ width: '100%' }}>
            <label className={classes.inputLabel}>
              Your password was successfully reset. You can now login with your
              email and new password.
            </label>
            <Box display="flex" justifyContent="flex-end">
              <Button
                type="button"
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={() => history.push(routes.LOGIN)}
              >
                Continue to Login
              </Button>
            </Box>
          </div>
        )}
        <div style={{ width: '100%' }}>
          <Box display="flex" justifyContent="flex-end">
            <Typography
              variant="body2"
              color="textPrimary"
              align="right"
              className={classes.version}
            >
              {getVersion()}
            </Typography>
          </Box>
        </div>
      </Paper>
    </Container>
  );
}
